import { Point } from 'pixi.js'
import gsap from 'gsap'
import resizer, { ResizerDimensions } from '../resizer'
import { clamp } from '../../utils/math'
import { getApp } from './sceneManager'
import Item from '../Item'
import { nowDayNumber } from '../../config/settings'
import { GlobalState } from '../../config/globalState'

export function moveStageToPosition(position: Point): void {
  const app = getApp()
  if (!app) return
  const dims = resizer.getDimensions()
  if (!dims) return

  const viewW = dims.stageW
  const viewH = dims.stageH
  const contentW = dims.stageW
  const contentH = dims.stageH

  const minX = Math.round(viewW - contentW)
  const maxX = 0
  const minY = Math.round(viewH - contentH)
  const maxY = 0

  const x = clamp(position.x, minX, maxX)
  const y = clamp(position.y, minY, maxY)

  gsap.to(app.stage, { duration: 1, x, y, overwrite: 'auto' })
}

export function centerStageOnItem(item: Item): void {
  const dims = resizer.getDimensions()
  if (!dims) return
  const c = item.getCenterPosition()
  const pos = new Point(dims.stageW / 2 - c.x * dims.scale, dims.stageH / 2 - c.y * dims.scale)
  moveStageToPosition(pos)
}

export function onResize(
  dims: ResizerDimensions,
  items: Item[],
  touchedItem: Item | undefined,
  openMobileActivityInfoBox: (item: Item) => void,
): Item | undefined {
  const app = getApp()
  if (!app) return

  // strict 16:9 canvas by resizing to stageW/H
  app.renderer.resize(dims.stageW, dims.stageH)

  const view = app.renderer.view as HTMLCanvasElement
  view.style.width = `${dims.stageW}px`
  view.style.height = `${dims.stageH}px`

  app.stage.scale.set(dims.scale)
  app.stage.x = 0
  app.stage.y = 0

  return
}
